<template>
  <div
    class="content d-inline"
    :class="{ highlight: highlight }"
    :style="{ background: color }"
  >
    <i
      v-if="iconLeft"
      v-show="hasIcon"
      class="far fa-times-circle pointer icon-left"
      @click="clickHandler"
    />
    <span class="title">{{ title }}</span>
    <i
      v-if="!iconLeft"
      v-show="!hasIcon"
      class="far fa-times-circle pointer icon-right"
      @click="clickHandler"
    />
  </div>
</template>

<script>
export default {
  name: 'Chip',
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
    iconLeft: {
      type: Boolean,
      default: () => false,
    },
    highlight: {
      type: Boolean,
      default: () => false,
    },
    hasIcon: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    clickHandler() {
      this.$emit('delete');
    },
  },
};
</script>

<style scoped>
.content {
  border: 1px solid #b5c3bc;
  border-radius: 13px;
  opacity: 1;
  display: inline-flex !important;
  margin: 5px;
}

.title {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  padding: 0 14px;
}

.icon-left {
  color: #c74545;
  margin-left: 5px;
  cursor: pointer;
}

.icon-right {
  color: #c74545;
  margin-right: 5px;
  cursor: pointer;
  padding: 4px 1px 4px 0px;
}

@-webkit-keyframes orange-fade {
  0% {
    background: #20a874;
    border: 0px solid #20a874;
    opacity: 1;
  }
  100% {
    background: none;
  }
}
@keyframes orange-fade {
  0% {
    background: #20a874;
    border: 0px solid #20a874;
    opacity: 1;
  }
  100% {
    background: none;
  }
}
.highlight {
  -webkit-animation: orange-fade 1s ease-in 1;
  animation: orange-fade 1s ease-in 1;
}
</style>
